import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AiAssistantFloatingButton from "@/components/ai/AiAssistantFloatingButton";
import AiAssistantChatDialog from "@/components/ai/AiAssistantChatDialog";
import { closeChat, openChat } from "../store/aiAssistant/aiAssitantSlice";

const AiAssistant = () => {
  const dispatch = useDispatch();
  const { isChatOpen, messages, searchLoading } = useSelector(
    (state) => state.ai
  );
  const handleOpenChat = () => {
    dispatch(openChat());
  };

  const handleCloseChat = () => {
    dispatch(closeChat());
  };

  return (
    <>
      {!isChatOpen && <AiAssistantFloatingButton onOpen={handleOpenChat} />}
      <AiAssistantChatDialog
        isOpen={isChatOpen}
        onClose={handleCloseChat}
        messages={messages}
        isLoading={searchLoading}
      />
    </>
  );
};

export default AiAssistant;
